module.exports = __webpack_public_path__ + "static/images/zhengxun.463e166.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/openPlatform/zhengxun.png
// module id = kHS+
// module chunks = 1